module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Brazil_Vitoria_Tanks-Landscape_2012-06-28_10.5adefc26.jpg";